export default __webpack_public_path__ + "static/media/img_chart_grade_D.f15c0c11e60d733bbcc032dc9ea7916c.svg";